import { Component, OnInit, inject } from '@angular/core'
import { RouterModule } from '@angular/router'
import { OidcSecurityService } from 'angular-auth-oidc-client'
import { AdminRoleService } from './shared/services/admin-role.service'

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  template: '<router-outlet />',
})
export class AppComponent implements OnInit {
  private readonly oidcSecurityService = inject(OidcSecurityService)
  private readonly roleService = inject(AdminRoleService)

  ngOnInit(): void {
    // The app's ONE AND ONLY checkAuth() call: restores an existing session
    // on load and consumes the code/state when Authentik redirects back.
    // Never add another (e.g. in the callback component) — checkAuth has no
    // in-flight dedup, and a concurrent second call re-processes the same
    // code, fails nonce validation, and resets the fresh session into an
    // infinite login loop. A failed callback throws here; the callback
    // component displays it via PublicEventsService, so just swallow.
    this.oidcSecurityService.checkAuth().subscribe({
      next: ({ isAuthenticated }) => {
        // Real role/permissions come from the Authentik JWT's groups,
        // resolved server-side (GET /admin/me) — load it as soon as we have
        // a token to send, so `AdminRoleService.hasPermission()` reflects
        // reality (not the read_only default) before the first gated action.
        if (isAuthenticated) this.roleService.load()
      },
      error: () => undefined,
    })
  }
}
